import React from "react";
import "./DeliveryOld.css";

function DeliveryOld() {
    return (
        <>
            <div className="delivery-main-container">

                {/* Section 1  */}
                <div className="dlf-container">
                    <div className="dlf-wrap">
                        <h2>Delivery Learning Framework (DLF 3.0)</h2>
                        <p className="intro-text">DLF3.0 is a set of pre-defined trainings for all career levels from Associate to Senior Managers. This will help enhance the required delivery skills while reinforcing existing knowledge.
                        </p>
                        <div className="dlf-row">
                            <div className="dlf-box">
                                {/* <a href="https://atci.lkm.delivery.accenture.com/DLF/DFA" target='_blank'> */}
                                <img src="./images/SLF/DFA.png" alt="DFA-img" className="dlf-imgs" />
                                <div className="dlf-box-content">
                                    <h3>Delivery Foundation Academy</h3>
                                    <p>Delivery Foundation Academy (DFA) features learnings designed to impart the basic delivery skills required at a specific career level. The learnings focuses on process, methodologies, programming fundamentals, tools and techniques required for a seamless delivery.
                                    </p>
                                    <a href="https://atci.lkm.delivery.accenture.com/DLF/DFA" target="_blank" className="dp-link">Delivery Foundation Academy</a>
                                </div>
                                {/* </a> */}
                            </div>
                            <div className="dlf-box">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/SecurityFoundationAcademy/" target='_blank'> */}
                                <img src="./images/SLF/SFA.png" alt="SFA-img" className="dlf-imgs" />
                                <div className="dlf-box-content">
                                    <h3>Security Foundation Academy</h3>
                                    <p>Security Foundation Academy covers basic security aspects that one should  be aware of and practice in their daily work. It includes the best practices to follow when accessing the production environment, the processes, controls and standards that must be followed to protect client data.
                                    </p>
                                    <a href="https://atci.lkm-securitylearnings.accenture.com/SecurityFoundationAcademy/" target="_blank" className="dp-link">Security Foundation Academy</a>
                                </div>
                                {/* </a> */}
                            </div>
                            <div className="dlf-box">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/" target='_blank'> */}
                                <img src="./images/SLF/DAA.png" alt="DAA-img" className="dlf-imgs" />
                                <div className="dlf-box-content">
                                    <h3>Delivery Adept Academy for Security</h3>
                                    <p>Delivery Adept Academy (DAA) for Security is designed for a career level with necessary security specialization to attain focused security delivery skills across security workforce.
                                    </p>
                                    <a href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/" target="_blank" className="dp-link">Delivery Adept Academy for Security</a>
                                </div>
                                {/* </a> */}
                            </div>

                        </div>
                    </div>
                </div>

                {/* Section 2  */}
                <div className="dp-container">
                    <div className="dp-wrap">
                        <h2>Delivery Programs</h2>
                        <p className="intro-text">Delivery Programs are for all employees to upskill and enhance on specific skills related to sales origination, building trusted client relationships and managing and growing complex SI projects.
                        </p>
                        <div className="dp-row row1">
                            <div className="dp-box">
                                <img src="./images/SLF/DP1.png" alt="dp-img" className="" />
                                <div className="dp-box-content">
                                    <h3>Delivery Lead Practitioner School</h3>
                                    <p>Delivery Lead Practitioner School is a deep skilled course, mandatory for CDL certifications. Mandatory for SI/AO Delivery lead certification. Provides deep insight into the delivery skills required for the Delivery leads to carry out their responsibilities.
                                    </p>
                                    <a href="https://deepknowledge.accenture.com/home/prog-dlps" target="_blank" className="dp-link">Deep Knowledge | Delivery Lead Practitioner School</a>
                                </div>
                            </div>
                            <div className="dp-box">
                                <img src="./images/SLF/DP2.png" alt="dp-img" className="" />
                                <div className="dp-box-content">
                                    <h3>Delivery Sales Academy</h3>
                                    <p>Delivery Sales Academy is a high-end leadership program that is designed to help you originate sales opportunities by building upon client relationships and effective positioning of Accenture offerings.
                                    </p>
                                    <a href="https://deepknowledge.accenture.com/home/prog-dsa" target="_blank" className="dp-link">Deep Knowledge | Delivery Sales Academy</a>
                                </div>
                            </div>
                        {/* </div> */}
                        {/* <div className="dp-row row2"> */}
                            <div className="dp-box">
                                <img src="./images/SLF/DP3.png" alt="dp-img" className="" />
                                <div className="dp-box-content">
                                    <h3>Project Management Foundation School</h3>
                                    <p>Project Management Foundation School (PMFS) is intended for the tenured Team Leads. It is a blended certification program with experience sharing by experts and self-study of key project management topics.
                                    </p>
                                </div>
                            </div>
                            <div className="dp-box">
                                <img src="./images/SLF/DP4.png" alt="dp-img" className="" />
                                <div className="dp-box-content">
                                    <h3>ITIL</h3>
                                    <p>ITIL is a key skillset required in the Service Management space.
                                        ITIL provides a framework for managing all aspects of IT service delivery from the development and deployment of new services to improvement and replacement of existing ones.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default DeliveryOld;